import { DateFormats } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';
import { type CcmStatuses, type RpmStatuses } from 'infrastructure/enums';
import {
  hasStatusForDisableCcmModule,
  hasStatusForDisableRpmModule,
} from 'infrastructure/functions/status-check';

export const formatReadingDate = (timestamp: number) => {
  const dateToCheck = new Date(Number.parseInt(String(timestamp), 10));

  return `Today, ${DateFormatter({
    date: dateToCheck,
    format: DateFormats['hh:mm:ss a'],
  })}`;
};

export const getProgramTypes = (
  rpmStatus?: RpmStatuses,
  ccmStatus?: CcmStatuses,
) => {
  const types = [];
  if (rpmStatus && !hasStatusForDisableRpmModule(rpmStatus)) types.push('RPM');
  if (ccmStatus && !hasStatusForDisableCcmModule(ccmStatus)) types.push('CCM');
  return types;
};
